import React, { lazy, Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import { ErrorBoundary } from '../../shared/components/ErrorBoundary';
import LoadingScreen from '../../shared/components/LoadingScreen';
import { Layout } from '../Layout';
import { Route, Routes, Navigate } from 'react-router-dom';
import { AgencyMessages } from './messages';
import AgencyInfluencers from './influencers';
import { SettingsRoutes } from '../shared/routes';

const AgencyInvoices = lazy(() => import('./invoices'));
const AgencyInvoicesArchive = lazy(() => import('./invoices/invoice-archive'));
const AgencyDashboard = lazy(() => import('./dashboard'));
const AgencyExplore = lazy(() => import('./explore'));
const AgencyOfferManagement = lazy(() => import('./offer'));
const AgencyPlanner = lazy(() => import('./planner'));
const AgencyReporting = lazy(() => import('./reporting'));
const AgencyAllCampaigns = lazy(() => import('./campaigns'));
const AgencyBriefingDetails = lazy(() => import('./campaigns/briefing/AgencyBriefingOverview'));
const ContentCreators = lazy(() => import('./content-creators'));
const DeclinedOffers = lazy(() => import('../influencer/declined-offers'));
const InfluencerProfile = lazy(() => import('../influencer/profile/profile-view'));
const ForbiddenPage = lazy(() => import('../../authentication/403'));

export function AgencyRoutes() {
    const { pathname } = useLocation();
    return (
        <Suspense fallback={<LoadingScreen />}>
            <ErrorBoundary key={pathname}>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/settings/*" element={<SettingsRoutes />} />
                        <Route path="/agency/invoices" element={<AgencyInvoices />} />
                        <Route path="/agency/invoices/archive" element={<AgencyInvoicesArchive />} />
                        <Route path="/agency/influencers" element={<AgencyInfluencers />} />
                        <Route path="/agency/dashboard" element={<AgencyDashboard />} />
                        <Route path="/agency/explore" element={<AgencyExplore />} />
                        <Route path="/agency/offers" element={<AgencyOfferManagement />} />
                        <Route path="/agency/planner" element={<AgencyPlanner />} />
                        <Route path="/agency/reporting" element={<AgencyReporting />} />
                        <Route path="/agency/messages/:id?" element={<AgencyMessages />} />
                        <Route path="/agency/campaigns" element={<AgencyAllCampaigns />} />
                        <Route path="/agency/campaign/:id/overview" element={<AgencyBriefingDetails />} />
                        <Route path="/agency/content-creators" element={<ContentCreators />} />
                        <Route path="/agency/offer/declined" element={<DeclinedOffers />} />
                        <Route path="/agency/influencer/profile/:id" element={<InfluencerProfile />} />
                        <Route path="/agency/influencer/edit/:id" element={<InfluencerProfile />} />
                        <Route path="/403" element={<ForbiddenPage />} />
                    </Route>
                    {/* <Route
                        path="/impersonate/:token/:id/:isAdmin/:adminActiveFirstRoute?/:adminActiveSecondRoute?/:adminActiveThirdRoute?"
                        element={<Impersonate />}
                    /> */}
                    <Route path="/auth/login" element={<Navigate to="/agency/influencers" replace />} />
                    <Route path="/" element={<Navigate to="/agency/influencers" replace />} />
                    <Route path="*" element={<Navigate to="/agency/influencers" replace />} />
                </Routes>
            </ErrorBoundary>
        </Suspense>
    );
}
